import React from 'react';

export const DispatchContext = React.createContext();
export const StateContext = React.createContext();
